import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Inventory } from 'src/app/interfaces/inventory';

@Component({
  selector: 'app-custom-dropdown-sede',
  templateUrl: './custom-dropdown-sede.component.html',
  styleUrls: ['./custom-dropdown-sede.component.scss'],
})
export class CustomDropdownSedeComponent implements OnInit {
  @Input() locations: Inventory[] = [];
  @Input() selectedInventory: number = 0;
  @Input() businessesName: any = '';
  @Input() businessesLogo: any = '';
  @Output() inventoryChange = new EventEmitter<number>();

  selectedLocation: any = {};
  dropdownOpen = false;

  ngOnInit() {
    this.locations.unshift({ id: 0, name: 'Todas', active: true });

    const defaultLocation =
      this.locations.find(location => location.id === this.selectedInventory) ||
      this.locations[0];
    this.selectedLocation = defaultLocation;

    // Sort locations by availability
    this.sortLocationsByAvailability();
  }

  // Sort locations by availability. Actives first, inactives at last.
  sortLocationsByAvailability(): void {
    this.locations.sort((a: Inventory, b: Inventory): number => {
      if (a.active && !b.active) return -1;
      return 1;
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectLocation(location: Inventory): void {
    this.selectedLocation = location;
    this.dropdownOpen = false;
    this.inventoryChange.emit(location.id);
  }
}
